module.exports = __webpack_public_path__ + "static/media/leafa-lose.f08f029e.png";